export const BUILD_HASH = 'c9ad118284bfa88e3f24b6c8ab9c8a';
